module.exports = __webpack_public_path__ + "static/img/particle-bg-min.522ce07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/particle-bg-min.png
// module id = 3oZ+
// module chunks = 1